module.exports = __webpack_public_path__ + "static/img/band4-big.4bcbe07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/band4-big.jpg
// module id = O7gS
// module chunks = 0